// @ts-nocheck
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PostApi } from "../../../ApiClient/PostApi";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { error_toaster, success_toaster } from "../../toaster/Toaster";

import { Loader2 } from "../../loader/Loader";
export default function NewPassword() {
  const navigate = useNavigate();
  const [data, setData] = useState({ confirm_password: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const onChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const login = async (event) => {
    event.preventDefault();

    if (data.confirm_password === "") {
      error_toaster("Confirm Password is required!");
      return false;
    } else if (data.password === "") {
      error_toaster("Password is required!");
      return false;
    } else if (data.password.length < 6) {
      error_toaster("Password length must be 6 or greater!");
      return false;
    } else if (data.password !== data.confirm_password) {
      error_toaster("Confirm Password mismatch!");
      return false;
    } else {
      setLoading(true);
      const res = await PostApi("users/change_password_after_otp", {
        email: localStorage.getItem("email"),
        password: data.password,
      });

      if (res.data.status === "1") {
        setLoading(false);
        success_toaster(res.data.message);
        navigate("/login");
      } else {
        setLoading(false);
        success_toaster(res.data.message);
      }
    }
  };
  const body = "body {background: #FFFFFF !important}";
  const inputStyle =
    "w-full bg-themeGray border-none font-normal sm:text-xl text-lg px-5 py-3 rounded-lg placeholder:text-black placeholder:text-opacity-40 focus:outline-none";
  return (
    <>
      <style>{body}</style>
      <section className="grid lg:grid-cols-2 h-[100vh]">
        <div className="bg-themeBlue lg:py-12 py-4 lg:px-12 px-2 flex lg:flex-col items-center justify-center lg:gap-y-12">
          <div className="lg:block hidden">
            <img
              src="images/dashboard/car_loader.webp"
              alt="cart"
              className="xl:w-[440px] lg:w-80"
            />
          </div>
          <Link to={"/"} className="p-0">
            <img src="images/logo.webp" alt="logo" className="xl:w-60 w-52" />
          </Link>
          <p className="font-normal xl:text-2xl lg:text-xl text-white text-center xl:w-4/5 mx-auto lg:block hidden">
            Lorem ipsum dolor sit amet consectetur. Vitae cras tortor nisl felis
            ultricies odio elementum ut. Sagittis mattis mauris commodo cras.
            Amet pellentesque morbi mauris blandit. Eu in at lectus dolor libero
            at integer tempus proin.
          </p>
        </div>
        {loading ? (
          <Loader2 />
        ) : (
          <div className="xl:w-1/2 lg:w-3/4 md:w-1/2 sm:w-2/3 w-4/5 mx-auto flex flex-col justify-center gap-y-8">
            <h1 className="font-bold sm:text-5xl text-4xl">New Password</h1>
            <div className="flex flex-col gap-y-4">
              <div className="relative w-full">
                <button
                  onClick={() => setVisible1(!visible1)}
                  type="button"
                  className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                >
                  {visible1 ? (
                    <AiOutlineEye size={28} />
                  ) : (
                    <AiOutlineEyeInvisible size={28} />
                  )}
                </button>
                <input
                  type={visible1 ? "text" : "password"}
                  onChange={onChange}
                  value={data.password}
                  name="password"
                  placeholder="Password"
                  className={inputStyle}
                />
              </div>

              <div className="relative w-full">
                <button
                  onClick={() => setVisible(!visible)}
                  type="button"
                  className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                >
                  {visible ? (
                    <AiOutlineEye size={28} />
                  ) : (
                    <AiOutlineEyeInvisible size={28} />
                  )}
                </button>
                <input
                  type={visible ? "text" : "password"}
                  onChange={onChange}
                  value={data.confirm_password}
                  name="confirm_password"
                  placeholder="Confirm Password"
                  className={inputStyle}
                />
              </div>
            </div>

            <button
              onClick={login}
              className="bg-themeBlue text-white font-medium sm:text-xl text-lg py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-transparent hover:text-themeBlue"
            >
              Submit
            </button>
          </div>
        )}
      </section>
    </>
  );
}
